// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';

type Props = {
  className?: string,
  date?: Date,
  fromMonth: Date,
  hasNavigationByYear?: boolean,
  onNext: () => void,
  onPrevious: () => void,
  toMonth: Date,
  // https://react-day-picker.js.org/api/DayPicker#captionElement
};

export function DatepickerCaption({
  className,
  date = new Date(),
  fromMonth,
  hasNavigationByYear,
  onNext,
  onPrevious,
  toMonth,
}: Props) {
  if (!hasNavigationByYear) return null;

  const currentYear = date.getFullYear();
  const fromYear = fromMonth.getFullYear();
  const toYear = toMonth.getFullYear();

  return (
    <div className={classnames(className, 'flex items-center justify-between')}>
      {currentYear > fromYear && (
        <button
          className="reset-button"
          onClick={() => onPrevious()}
          style={{ width: 30, height: 30 }}
          type="button"
        >
          <Icon
            color={COLORS.GRAY_DARKER}
            name={ICONS.BOLDER_ARROW_FORTH}
            rotation={180}
            width="0.625rem"
          />
        </button>
      )}
      <span className="flex-1">{date.getFullYear()} </span>
      {currentYear < toYear && (
        <button
          className="reset-button"
          onClick={() => onNext()}
          style={{ width: 30, height: 30 }}
          type="button"
        >
          <Icon color={COLORS.GRAY_DARKER} name={ICONS.BOLDER_ARROW_FORTH} width="0.625rem" />
        </button>
      )}
    </div>
  );
}
